import { z } from 'zod';

const SChatMemberExtraAttributes = z.object({
  branch_id: z.number().nullable(),
});

export const SChatMember = z.object({
  id: z.number(),
  name: z.string(),
  extra_attributes: SChatMemberExtraAttributes.nullable(),
});
export type TChatMember = z.infer<typeof SChatMember>;
